// extracted by mini-css-extract-plugin
export default {"Error":"Container_Error__78xGK","Wrapper":"Container_Wrapper__-nuK-"};